export class EventEmitter {
    constructor() {
        this.events = {};
    }
    on(event, callback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
        return () => this.off(event, callback);
    }
    off(event, callback) {
        if (!this.events[event])
            return;
        this.events[event] = this.events[event].filter((handler) => handler !== callback);
        if (this.events[event].length === 0) {
            delete this.events[event];
        }
    }
    emit(event, data) {
        if (!this.events[event])
            return;
        const handlers = [...this.events[event]];
        for (const handler of handlers) {
            try {
                handler(data);
            }
            catch (error) {
                console.error(`Error in event "${event}" handler:`, error);
            }
        }
    }
    once(event, callback) {
        const onceHandler = (data) => {
            this.off(event, onceHandler);
            callback(data);
        };
        this.on(event, onceHandler);
    }
    getEventListeners(event) {
        var _a;
        if (event) {
            return ((_a = this.events[event]) === null || _a === void 0 ? void 0 : _a.length) || 0;
        }
        return Object.fromEntries(Object.entries(this.events).map(([key, handlers]) => [key, handlers.length]));
    }
    clear(event) {
        if (event) {
            delete this.events[event];
        }
        else {
            this.events = {};
        }
    }
}
